module.exports = __webpack_public_path__ + "images/logo-vert-cf4842da.png";